// Owner 2026-10-08: every time and date on screen is in the business time
// zone (setting "Zona waktu", WIT for the shop in Sorong), never the clock of
// the device. No imports, so Jest can test it. The zone is loaded once from
// /api/public/branding (ZonaWaktu in App.js); until then WIT.

let ZONA = "Asia/Jayapura";
const SINGKAT = { "Asia/Jakarta": "WIB", "Asia/Makassar": "WITA", "Asia/Jayapura": "WIT" };

export function setZona(z) {
  if (typeof z === "string" && z) {
    try { new Intl.DateTimeFormat("id-ID", { timeZone: z }); ZONA = z; } catch { /* unknown zone: keep */ }
  }
  return ZONA;
}
export const zona = () => ZONA;
export const zonaSingkat = () => SINGKAT[ZONA] || ZONA;

const fmt = (iso, opsi) => {
  if (!iso) return "—";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return new Intl.DateTimeFormat("id-ID", { timeZone: ZONA, ...opsi }).format(d);
};

// 08/10/26 14.05
export const waktu = (iso) => fmt(iso, { dateStyle: "short", timeStyle: "short" });
// 8 Okt 2026 14.05
export const waktuSedang = (iso) => fmt(iso, { dateStyle: "medium", timeStyle: "short" });
// 08/10/2026
export const tanggal = (iso) => fmt(iso, { day: "2-digit", month: "2-digit", year: "numeric" });
// 8 Oktober 2026
export const tanggalPanjang = (iso) => fmt(iso, { dateStyle: "long" });
// 08 Okt
export const tanggalSingkat = (iso) => fmt(iso, { day: "2-digit", month: "short" });
// 14.05
export const jam = (iso) => fmt(iso, { hour: "2-digit", minute: "2-digit" });
// 14.05.09
export const jamDetik = (iso) => fmt(iso, { hour: "2-digit", minute: "2-digit", second: "2-digit" });

// today's business date "YYYY-MM-DD" in the business zone (default value of date inputs)
export function hariIni(sekarang = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: ZONA, year: "numeric", month: "2-digit", day: "2-digit" }).format(sekarang);
}
